/**
 * /app/{slug}/helpdesk/tickets/{id} — one helpdesk ticket: conversation,
 * status and (for the helpdesk) assignment. Persona round wave B.
 *
 * Not nested under the /helpdesk list layout (the trailing underscore):
 * the ticket page replaces the list rather than rendering below it. The
 * helpdesk notifications link here (backend ticketLinkPrefix).
 */

import { createFileRoute } from "@tanstack/react-router";
import { HelpdeskTicketDetail } from "@/components/helpdesk/helpdesk-ticket-detail";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/helpdesk_/tickets/$id",
)({
  component: HelpdeskTicketRoute,
});

function HelpdeskTicketRoute() {
  const { tenantSlug, id } = Route.useParams();
  return <HelpdeskTicketDetail ticketId={Number(id) || 0} tenantSlug={tenantSlug} />;
}
